import { withMotion } from '../hoc/with-motion';
import { OrgHostingPodcast } from '@/modules/manager/components/org/hosting-podcast';

const AnimatedPage = withMotion(OrgHostingPodcast);

export const roles: string[] = [];
export const path = '/manager/:orgId/hosting-podcast/:podcastId';
export const element = <AnimatedPage />